<template>
  <modal :visible.sync="visibleSync"
         width="550px"
         :height="'fit-content'"
  >
    <template slot="header">
      <span class="cancel-project__title bold"> {{ $t('validate.cancelProjectTitle') }} </span>
    </template>
    <span class="cancel-project__content" v-if="!isCancelSaving">
      <template>
        <div class="cancel-project__content__input">
          <p class="cancel-project__content__input__label">
            {{ $t('validate.cancelLabel') }}
          </p>
          <input-select optionValue=""
                        required :options="options" v-model="status"></input-select>
        </div>
        <div class="cancel-project__content__input"
             v-if="status.value === 'CANCEL_REASON_OTHER'">
          <p>{{ $t('validate.cancelDescriptionLabel') }}</p>
          <el-input
            :placeholder="$t('validate.cancelPlaceholder.other')"
            type="textarea"
            maxlength="150"
            v-model="status.description">
          </el-input>
        </div>
        <div class="cancel-project__content__notice">
          {{ $t('validate.cancelProjectInfos') }}
        </div>
      </template>
    </span>
    <div v-else class="loading">
      <Loader />
    </div>
    <br/>
    <template slot="footer">
      <div class="cancel-project__footer">
        <button class="cancel-project__footer__left nxt-button --disabled"
                :disabled="isCancelSaving"
                @click="visibleSync = false">
          {{ $t('base.no') }}
        </button>
        <button @click="cancelProject"
                :disabled="isCancelSaving"
                class="cancel-project__footer__right nxt-button nxt-button__primary --disabled">
          {{ $t('validate.cancel') }}
        </button>
      </div>
    </template>
  </modal>
</template>

<script>
import { mapGetters } from 'vuex';
import Loader from '@/components/utils/Loader.vue';
import Modal from '../Modal.vue';
import InputSelect from '../InputSelect.vue';

export default {
  name: 'CancelProjectModal',
  components: {
    Modal, InputSelect, Loader,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      status: {
        label: this.$t('validate.cancelStatus.budget'),
        value: 'CANCEL_REASON_BUDGET',
      },
      options: [
        {
          label: this.$t('validate.cancelStatus.budget'),
          value: 'CANCEL_REASON_BUDGET',
        },
        {
          label: this.$t('validate.cancelStatus.concurrents'),
          value: 'CANCEL_REASON_OTHER_OFFERS',
        },
        {
          label: this.$t('validate.cancelStatus.estimOnly'),
          value: 'CANCEL_REASON_ESTIM_ONLY',
        },
        {
          label: this.$t('validate.cancelStatus.tooDifficult'),
          value: 'CANCEL_REASON_TOO_DIFFICULT',
        },
        {
          label: this.$t('validate.cancelStatus.other'),
          value: 'CANCEL_REASON_OTHER',
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      isCancelSaving: 'projectStore/isCancelSaving',
    }),
    isMobile() {
      return this.$store.getters['dimensionStore/isMobile'];
    },
    visibleSync: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      },
    },
  },
  methods: {
    cancelProject() {
      this.$store.dispatch('projectStore/cancelProject', this.status);
    },
  },
  watch: {
    isCancelSaving(value) {
      if (!value) {
        this.visibleSync = false;
        this.$nextTick(() => {
          const validateElement = document.getElementsByClassName('validate');
          if (validateElement && validateElement[0]) {
            validateElement[0].scrollIntoView(true);
          }
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .dialog__content__body {
  overflow-x: hidden;
}
.cancel-project {
  &__title {
    display: block;
    font-weight: $--font-weight-600;
    font-size: $--font-size-large;
  }
  &__content{
    display: block;
    margin: 5px 0;
    text-align: initial;
    font-size: $--font-size-medium;

    &__input {
      margin: auto;
      width: 100%;
      &__label {
        font-weight: $--font-weight-500;
      }
      .el-select {
        width: 100%;
      }
    }

    &__notice {
      margin-top: 10px;
      font-style: italic;
    }
  }
  &__footer {
    margin-top: 20px;
    display: grid;
    grid-template-columns: auto auto;
    grid-template-areas: "left right";
    column-gap: 15px;

    @include breakpoint(mobile) {
      grid-template-columns: auto 200px 200px auto;
      grid-template-areas: ". left right .";
    }

    &__left {
      grid-area: left;
    }

    &__right {
      grid-area: right;
    }
  }
}

.loading {
  height: 180px;
  width: 100%;
  display: flex;
}

.el-button{
  margin: 0 15px;
}

::v-deep .el-dialog--center .el-dialog__body {
  text-align: center;
}

::v-deep .dialog__content__body{
  text-align: center;
}
</style>
